import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faSun,
  faMoon,
  faCheck,
  faInfoCircle,
  faAngleDoubleUp,
  faExternalLinkAlt,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';

import {
  faEtsy,
  faVuejs,
  faGithub,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faSun,
  faMoon,
  faEtsy,
  faVuejs,
  faCheck,
  faGithub,
  faTwitter,
  faInfoCircle,
  faAngleDoubleUp,
  faExternalLinkAlt,
  faExclamationCircle
);
